import React from "react";
import DatePicker from "react-datepicker";
import { FormGroup, Label, Input, InputProps } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";

import "./Input.scss";
interface FormInputProps extends InputProps {
  name: string;
  label?: string;
  error?: any;
  touched?: any;
}

const formatDateForValue = (date: Date | null) => {
  if (!date) {
    return "";
  }

  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const parseDateValue = (value: unknown): Date | null => {
  if (!value || typeof value !== "string") {
    return null;
  }

  const date = new Date(`${value}T00:00:00`);
  return Number.isNaN(date.getTime()) ? null : date;
};

const FormInput: React.FC<FormInputProps> = ({ name, label, error, touched, ...inputProps }) => {
  const { type, onChange, onBlur, value, placeholder, disabled, readOnly, id, ...restProps } =
    inputProps;

  const resolvedPlaceholder =
    placeholder || (type === "date" ? "DD/MM/YYYY" : label ? `${label}` : undefined);

  if (type === "date") {
    const selectedDate = parseDateValue(value);

    return (
      <FormGroup>
        {label && <Label htmlFor={name}>{label}</Label>}

        <DatePicker
          id={id || name}
          name={name}
          selected={selectedDate}
          onChange={(date: Date | null) => {
            const formattedValue = formatDateForValue(date);
            onChange?.({ target: { name, value: formattedValue } } as any);
          }}
          onBlur={() => {
            onBlur?.({ target: { name, value: value || "" } } as any);
          }}
          dateFormat='dd/MM/yyyy'
          placeholderText={resolvedPlaceholder as string}
          disabled={disabled}
          readOnly={readOnly}
          className={`form-control ${touched && error ? "is-invalid" : ""}`}
          autoComplete='off'
        />

        {touched && error && <small className='text-danger fw-medium'>{error}</small>}
      </FormGroup>
    );
  }

  return (
    <FormGroup>
      {label && <Label htmlFor={name}>{label}</Label>}

      <Input
        invalid={touched && error}
        id={id || name}
        name={name}
        type={type}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        placeholder={resolvedPlaceholder as string}
        {...restProps}
      />
      {touched && error && <small className='text-danger fw-medium'>{error}</small>}
    </FormGroup>
  );
};

export default FormInput;
